import React from "react";

import { format } from "date-fns";

import { Box, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import Table from "./Table";

export const Regularidade = ({ data }) => {
  const columnsNrRegistroCMDCA = [
    {
      Header: "Número de Registro",
      accessor: "numeroRegistro",
      Cell: (props) => {
        return (
          <span
            title={props.value}
            style={{
              wordBreak: "break-word",
            }}
          >
            {props.value ? props.value : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Validade",
      accessor: "validadeNrRegistro",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Data do Documento",
      accessor: "dataAnexoNrRegistro",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
  ];

  const columnsNrInscricaoCMDCA = [
    {
      Header: "Número de Inscrição",
      accessor: "numeroInscricao",
      Cell: (props) => {
        return (
          <span
            title={props.value}
            style={{
              wordBreak: "break-word",
            }}
          >
            {props.value ? props.value : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Validade",
      accessor: "validadeNrInscricao",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Data do Documento",
      accessor: "dataAnexoNrInscricao",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
  ];

  const columnsNrInscricaoCMAS = [
    {
      Header: "Número de Inscrição",
      accessor: "numeroInscricaoCMAS",
      Cell: (props) => {
        return (
          <span
            title={props.value}
            style={{
              wordBreak: "break-word",
            }}
          >
            {props.value ? props.value : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Validade",
      accessor: "validadeNrInscricaoCMAS",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
    {
      Header: "Data do Documento",
      accessor: "dataAnexoNrInscricaoCMAS",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(props.value, "dd/MM/yyyy") : "Não possui"}
          </span>
        );
      },
    },
  ];

  return data ? (
    <Box className="break-page">
      <Group
        title="Regularidade do Serviço"
        bgColor="#DDEBEA"
        mt="15px"
        py="12px"
        mtDivider="5px"
      >
        <Text
          mt="15px"
          fontWeight={700}
          fontSize="14px"
          lineHeight="19.6px"
          color="#797A80"
        >
          CMDCA
        </Text>
        {data.servicoAcolhimento?.naturezaServico === "privada" && (
          <Table data={[data]} columns={columnsNrRegistroCMDCA} />
        )}
        <Table data={[data]} columns={columnsNrInscricaoCMDCA} />
        {data.servicoAcolhimento?.naturezaServico === "privada" && (
          <>
            <Text
              mt="15px"
              fontWeight={700}
              fontSize="14px"
              lineHeight="19.6px"
              color="#797A80"
            >
              CMAS
            </Text>
            <Table data={[data]} columns={columnsNrInscricaoCMAS} />
          </>
        )}
      </Group>
    </Box>
  ) : (
    <Box className="break-page">
      <Group
        bgColor="#DDEBEA"
        title="Regularidade do Serviço"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
